<template>
    <div class="mb-3" v-if="shouldShow(formKey)" :class="{'col-md-6': multiColumn}">
        <strong>{{mappedKey(formKey)}}:</strong>
        <br v-if="newline" />
        <ul v-if="Array.isArray(value)">
            <li v-for="nestedValue in value">
                <span class="displayValue">{{nestedValue}}</span>
            </li>
        </ul>
        <div class="nested border-hr border-left" v-else-if="value instanceof Object">
            <div class="data">
                <template v-for="(nestedValue, nestedKey) in value" v-if="shouldShow(nestedKey)">
                    <formdata-display :key="nestedKey" :formKey="nestedKey" :value="nestedValue" :newline="false" :multiColumn="multiColumn"></formdata-display>
                </template>
            </div>
        </div>
        <div v-else>
            <span class="displayValue">{{mappedValue(formKey, value)}}</span>
        </div>
    </div>
</template>

<script>
    import formKeys from './../helpers/formKeys';

    export default {
        components: {
        },
        props: {
            formKey: {
                type: String,
                required: true
            },
            value: {
                type: String|Object|null
            },
            newline: {
                type: Boolean,
                default: true
            },
            multiColumn: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
            }
        },
        watch: {
        },
        mounted() {
        },
        computed: {
        },
        methods: {
            mappedKey(key) {
                return formKeys.mapKey(key, key);
            },
            mappedValue(key, value) {
                return formKeys.mapValue(key, value, '-');
            },
            shouldShow(key) {
                return formKeys.shouldShow(key);
            }
        }
    }
</script>

<style lang="scss">
    .nested {
        padding-left: 8px;
    }

    .displayValue {
        white-space: pre-wrap;
        overflow-wrap: break-word;
        word-wrap: break-word;

        -ms-word-break: break-all;
        /* This is the dangerous one in WebKit, as it breaks things wherever */
        word-break: break-all;
        /* Instead use this non-standard one: */
        word-break: break-word;

        /* Adds a hyphen where the word breaks, if supported (No Blink) */
        -ms-hyphens: auto;
        -moz-hyphens: auto;
        -webkit-hyphens: auto;
        hyphens: auto;
    }
</style>